import { State } from "@/models/state.model";
import { api, ApiResponse } from "./api";

export const stateService = {
    getAllStates: (): Promise<ApiResponse<{states: State[]}>> => {
    // For demo purposes, simulate API call
    return api.get<ApiResponse<{states: State[]}>>("/states/list");
  },
}